import React from "react";
import { Award, ImagePlus } from "lucide-react";
import { AWARDS } from "../data";

export default function Awards() {
  return (
    <div data-testid="awards-page" className="relative">
      <span className="stamp-num absolute top-6 right-6 md:right-12">N° 05</span>

      <section className="max-w-7xl mx-auto px-6 md:px-12 pt-12 md:pt-16 pb-14">
        <p className="section-num">
          <strong>05</strong> Awards &amp; recognition
        </p>
        <div className="grid md:grid-cols-12 gap-10 items-end mt-5">
          <h1 className="md:col-span-8 font-display text-display-xl text-ink tracking-tightest fade-up">
            Recognised by
            <br />
            <span className="font-italic text-coral">institutions and peers.</span>
          </h1>
          <p className="md:col-span-4 text-ink/65 max-w-md text-[15px] leading-relaxed fade-up-d1">
            Certifications, awards, MoUs and press features that mark our
            journey as a research and training centre.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-12 pb-32">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {AWARDS.map((a, i) => (
            <article
              key={`${a.year}-${a.title}-${i}`}
              className="group bg-boneSoft rounded-4xl overflow-hidden border border-ink/5 shadow-soft hover:shadow-hoverCard lift flex flex-col"
            >
              <div className="aspect-[4/3] bg-sageMist grid place-items-center text-sage/60">
                <ImagePlus className="h-10 w-10 opacity-60" />
              </div>
              <div className="p-6 md:p-7 flex-grow flex flex-col">
                <div className="flex items-center justify-between">
                  <Award className="h-5 w-5 text-coral" />
                  <span className="text-[10px] uppercase tracking-[0.22em] text-muted tabular-nums">
                    {a.year}
                  </span>
                </div>
                <h3 className="font-display text-[24px] mt-4 text-ink leading-tight tracking-tightest">
                  {a.title}
                </h3>
                <p className="mt-3 text-ink/60 text-sm leading-relaxed">{a.body}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-12 rounded-3xl bg-sageMist/60 border border-sage/30 p-6 text-sageDeep text-sm">
          Award and certificate images will be uploaded by the team — current
          tiles are placeholders that show the layout. Send the photos and
          we'll swap them in.
        </div>
      </section>
    </div>
  );
}
